import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "./accordion";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogMedia,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./alert-dialog";
import { Button, buttonVariants } from "./button";
import { Calendar } from "./calendar";
import { Checkbox } from "./checkbox";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from "./dialog";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "./dropdown-menu";
import {
  Field,
  FieldLabel,
  FieldDescription,
  FieldError,
  FieldGroup,
  FieldLegend,
  FieldSeparator,
  FieldSet,
  FieldContent,
  FieldTitle,
} from "./field";
import { Input } from "./input";
import { Label } from "./label";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { RadioGroup, RadioGroupItem } from "./radio-group";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "./select";
import { Separator } from "./separator";
import { Slider } from "./slider";
import { Switch } from "./switch";
import { Textarea } from "./textarea";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./tooltip";
import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "./breadcrumb";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerTitle,
  DrawerTrigger,
} from "./drawer";

export const UIComponents = {
  accordion: Accordion,
  accordionItem: AccordionItem,
  accordionTrigger: AccordionTrigger,
  accordionContent: AccordionContent,
  alertDialog: AlertDialog,
  alertDialogAction: AlertDialogAction,
  alertDialogCancel: AlertDialogCancel,
  alertDialogContent: AlertDialogContent,
  alertDialogDescription: AlertDialogDescription,
  alertDialogFooter: AlertDialogFooter,
  alertDialogHeader: AlertDialogHeader,
  alertDialogMedia: AlertDialogMedia,
  alertDialogOverlay: AlertDialogOverlay,
  alertDialogPortal: AlertDialogPortal,
  alertDialogTitle: AlertDialogTitle,
  alertDialogTrigger: AlertDialogTrigger,
  button: Button,
  buttonVariants: buttonVariants,
  calendar: Calendar,
  checkbox: Checkbox,
  dialog: Dialog,
  dialogClose: DialogClose,
  dialogContent: DialogContent,
  dialogDescription: DialogDescription,
  dialogFooter: DialogFooter,
  dialogHeader: DialogHeader,
  dialogOverlay: DialogOverlay,
  dialogPortal: DialogPortal,
  dialogTitle: DialogTitle,
  dialogTrigger: DialogTrigger,
  dropdownMenu: DropdownMenu,
  dropdownMenuCheckboxItem: DropdownMenuCheckboxItem,
  dropdownMenuContent: DropdownMenuContent,
  dropdownMenuGroup: DropdownMenuGroup,
  dropdownMenuItem: DropdownMenuItem,
  dropdownMenuLabel: DropdownMenuLabel,
  dropdownMenuPortal: DropdownMenuPortal,
  dropdownMenuRadioGroup: DropdownMenuRadioGroup,
  dropdownMenuRadioItem: DropdownMenuRadioItem,
  dropdownMenuSeparator: DropdownMenuSeparator,
  dropdownMenuShortcut: DropdownMenuShortcut,
  dropdownMenuSub: DropdownMenuSub,
  dropdownMenuSubContent: DropdownMenuSubContent,
  dropdownMenuSubTrigger: DropdownMenuSubTrigger,
  dropdownMenuTrigger: DropdownMenuTrigger,
  field: Field,
  fieldLabel: FieldLabel,
  fieldDescription: FieldDescription,
  fieldError: FieldError,
  fieldGroup: FieldGroup,
  fieldLegend: FieldLegend,
  fieldSeparator: FieldSeparator,
  fieldSet: FieldSet,
  fieldContent: FieldContent,
  fieldTitle: FieldTitle,
  input: Input,
  label: Label,
  popover: Popover,
  popoverContent: PopoverContent,
  popoverTrigger: PopoverTrigger,
  radioGroup: RadioGroup,
  radioGroupItem: RadioGroupItem,
  select: Select,
  selectContent: SelectContent,
  selectGroup: SelectGroup,
  selectItem: SelectItem,
  selectLabel: SelectLabel,
  selectScrollDownButton: SelectScrollDownButton,
  selectScrollUpButton: SelectScrollUpButton,
  selectSeparator: SelectSeparator,
  selectTrigger: SelectTrigger,
  selectValue: SelectValue,
  separator: Separator,
  slider: Slider,
  switch: Switch,
  textarea: Textarea,

  tooltip: Tooltip,
  tooltipContent: TooltipContent,
  tooltipProvider: TooltipProvider,
  tooltipTrigger: TooltipTrigger,
  breadcrumb: Breadcrumb,
  breadcrumbList: BreadcrumbList,
  breadcrumbItem: BreadcrumbItem,
  breadcrumbLink: BreadcrumbLink,
  breadcrumbPage: BreadcrumbPage,
  breadcrumbSeparator: BreadcrumbSeparator,
  breadcrumbEllipsis: BreadcrumbEllipsis,
  drawer: Drawer,
  drawerPortal: DrawerPortal,
  drawerOverlay: DrawerOverlay,
  drawerTrigger: DrawerTrigger,
  drawerClose: DrawerClose,
  drawerContent: DrawerContent,
  drawerHeader: DrawerHeader,
  drawerFooter: DrawerFooter,
  drawerTitle: DrawerTitle,
  drawerDescription: DrawerDescription,
};
